import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../../../state/modals-dux';


class RestoreVersionModal extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { openModal, closeModal, versionToRestore, handleRestoreVersion, restoreVersionInProgress } = this.props;
    const { versionName } = versionToRestore || {};
    return (
      <Modal show={openModal === 'RestoreVersionModal'} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Publish version {versionName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!restoreVersionInProgress && (
            <span>Do you want to publish version {versionName}?</span>
          )}
          {restoreVersionInProgress && (
            <span>Loading ...</span>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button type="button" bsStyle="success" onClick={handleRestoreVersion} disabled={restoreVersionInProgress}>
            <span className="ti ti-check" /> Publish
          </Button>
          {' '}
          <Button type="button" bsStyle="hollow-info" onClick={closeModal} disabled={restoreVersionInProgress}>
            <span className="ti ti-close" /> Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}


const mapState = state => ({ openModal: state.modals });
const mapDispatch = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapState, mapDispatch)(RestoreVersionModal);



// WEBPACK FOOTER //
// ./src/components/routes/assets/RestoreVersionModal.js